import { render } from "./JumpLaboProfile.vue?vue&type=template&id=06aad94a&scoped=true&ts=true"
import script from "./JumpLaboProfile.vue?vue&type=script&lang=ts"
export * from "./JumpLaboProfile.vue?vue&type=script&lang=ts"

import "./JumpLaboProfile.vue?vue&type=style&index=0&id=06aad94a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1488180328/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06aad94a"]])

export default __exports__